export default {
    palette: {
        id: 1,
        name: 'palette',
        colors: [
            '45, 74, 197',
            '255, 166, 0',
            '198, 44, 168',
            '255, 93, 79',
            '238, 36, 141',
            '255, 58, 110',
            '141, 61, 188',
            '255, 130, 46'
        ]
    },
    single: {
        id: 2,
        name: 'single',
        colors: [
            '45, 74, 197',
            '184, 177, 239',
            '84, 93, 206',
            '161, 155, 231',
            '112, 113, 214',
            '205, 199, 247',
            '138, 134, 222',
            '227, 222, 255'
        ]
    },
    divergent: {
        id: 3,
        name: 'divergent',
        colors: [
            '45, 74, 197',
            '149, 91, 192',
            '202, 119, 189',
            '235, 157, 193',
            '255, 200, 210',
            '255, 188, 184',
            '255, 182, 145',
            '255, 184, 99',
            '253, 194, 45'
        ]
    }
}
